const Affiliate = (props) => {
  let affiliateSource = props.source;

  if (!localStorage.getItem("affiliate_source")) {
    localStorage.setItem("affiliate_source", affiliateSource);
  }
};

export default Affiliate;
